import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
const PMButton = styled.button`
  background: #ee754c;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    filter: brightness(0.95);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
function PaymentMethodManager({
  restaurantId
}) {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {
    userInfo
  } = useSelector(s => s.userLogin || {});
  const goToPortal = async () => {
    if (!userInfo?.token) {
      toast.error(t("ui.i18nMessages.loginToManagePayment"));
      return;
    }
    try {
      setLoading(true);
      const res = await fetch("/api/payments/portal-session/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userInfo.token}`
        },
        body: JSON.stringify({
          restaurant_id: restaurantId
        })
        // if you're using cookies/session auth instead of JWT:
        // credentials: "include",
      });

      // handle non-JSON responses (e.g., HTML error/redirect)
      const ct = res.headers.get("content-type") || "";
      const payload = ct.includes("application/json") ? await res.json() : {
        error: await res.text()
      };
      if (!res.ok) {
        const msg = payload?.error || t("ui.i18nFinalCleanup.portalSessionFailed", { status: res.status, statusText: res.statusText });
        throw new Error(msg);
      }
      if (!payload?.url) {
        throw new Error(t("ui.i18nFinalCleanup.invalidServerResponseNoUrl"));
      }
      window.location.href = payload.url;
    } catch (err) {
      toast.error(err.message || t("ui.i18nFinalCleanup.couldNotOpenBillingPortal"));
    } finally {
      setLoading(false);
    }
  };
  return <div>
      <p className="text-muted" style={{
      marginBottom: 8
    }}>{t("ui.components.paymentMethodManager.atualizaOMetodoDePagamentoE")}</p>
      <PMButton onClick={goToPortal} disabled={loading || !restaurantId}>
        {loading ? t("ui.i18nCleanup2.aAbrir") : t("ui.i18nCleanup2.gerirPagamentoEFaturacao")}
      </PMButton>
    </div>;
}
export default PaymentMethodManager;
